import { ref } from 'vue'

const activeModalId = ref<string | null>(null)
const activeModalData = ref<Record<string, any>>({})

export function useModal() {
	const openModal = (modalId: string, data?: Record<string, any>) => {
		activeModalId.value = modalId

		// You can use props to pass data to the modal if needed
		if (data && typeof data === 'object') {
			activeModalData.value = data
		}

		// Finally, set the active modal ID to open the modal
		activeModalId.value = modalId
	}

	const closeModal = () => {
		activeModalId.value = null
		setTimeout(() => {
			activeModalData.value = {}
		}, 300) // Reset props after a short delay to allow modal close animation
	}

	const isModalOpen = (modalId: string) => {
		return activeModalId.value === modalId
	}

	return {
		activeModalId,
		activeModalData,
		openModal,
		closeModal,
		isModalOpen
	}
}
